import styled from 'styled-components';

import { LOGO_MAX_HEIGHT } from './constants';

export const StyledLogo = styled.div`
  margin: 0 auto 0;
  max-height: ${LOGO_MAX_HEIGHT};
  min-width: 120px;

  & > svg {
    max-height: inherit;
  }
`;
